module.exports = __webpack_public_path__ + "static/media/Gotham-Book.872f5c46.woff";